export default "__VITE_ASSET__DtdE6LTv__"